module.exports = __webpack_public_path__ + "static/media/new-old-count.240d178d.png";